import React from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Drawer } from 'rsuite'
import { LoaderBtn } from '../Loader/Loader-btn'
import 'rsuite/dist/rsuite.css'

function FicheDrawerComposantUseForm(props) {
  const { t } = useTranslation()
  const titleFiche = props.isEdit ? props.titleEdit : props.titleNew
  const isDefault = props.default && props.default === true

  const commonBody = (
    <>
      <Drawer.Header className={props.headerClassName}>
        <Drawer.Title>{props.title ?? titleFiche}</Drawer.Title>
        {props.headerChildren}
        {!props.hideActions && (
          <Drawer.Actions>
            {!props.noCancel && (
              <Button
                variant="outline-primary"
                style={{ margin: '0px 0px 0px 10px' }}
                className="primary-outline-button"
                onClick={props.onClose}
              >
                {t('cash.settings.SmartTags.fiche.buttons.back')}
              </Button>
            )}
            {props.rappro && (
              <Button
                variant="light"
                style={{ margin: '0px 0px 0px 10px' }}
                onClick={props.rappro}
              >
                {t('Rappro')}
              </Button>
            )}
            {props.other_buttons}
            {!props.isViewMode && (
              <Button
                variant="primary"
                className="primary-button"
                style={{ margin: '0px 0px 0px 10px' }}
                type="submit"
                disabled={props.disabled && props.disabled === true}
                onClick={props.click}
              >
                {props.loaderCreate ? (
                  <LoaderBtn />
                ) : (
                  t('cash.referentiel.Mandats.fiche.buttons.save')
                )}
              </Button>
            )}
          </Drawer.Actions>
        )}
      </Drawer.Header>
      <Drawer.Body className={props.bodyClassName} style={{ padding: '30px' }}>
        {props.cardBody}
      </Drawer.Body>
    </>
  )
  return (
    <Drawer
      open={props.open}
      onClose={props.onClose}
      backdrop={props.backdrop}
      size={props.size}
      enforceFocus={false}
    >
      {isDefault ? (
        commonBody
      ) : (
        <form
          className="h-100 w-100"
          onSubmit={(e) => {
            props.isViewMode || props.noValidate
              ? e.preventDefault()
              : props.handleSubmit(props.onSubmit)(e)
            e.stopPropagation()
          }}
        >
          {commonBody}
        </form>
      )}
    </Drawer>
  )
}
export default FicheDrawerComposantUseForm

